var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 443.329 273.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m118.467,245.81l-10.691,26.881h3.98l2.846-7.509h11.903l2.921,7.509h4.019l-10.694-26.881h-4.284Zm-2.539,15.925l4.588-12.058,4.662,12.058h-9.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.976 266.436 145.555 245.81 140.589 245.81 140.589 272.692 144.305 272.692 144.305 250.776 158.825 272.692 162.692 272.692 162.692 245.81 158.976 245.81 158.976 266.436",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.524,245.81l-10.691,26.881h3.98l2.846-7.509h11.903l2.921,7.509h4.019l-10.694-26.881h-4.284Zm-2.539,15.925l4.588-12.058,4.662,12.058h-9.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.361 245.81 202.646 245.81 202.646 272.692 219.062 272.692 219.062 269.202 206.361 269.202 206.361 245.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.684 257.791 224.707 245.81 220.232 245.81 229.713 261.202 229.713 272.692 233.428 272.692 233.428 261.202 242.908 245.81 238.659 245.81 231.684 257.791",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.52 249.261 257.505 249.261 257.505 272.692 261.221 272.692 261.221 249.261 270.206 249.261 270.206 245.81 248.52 245.81 248.52 249.261",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.353,
    y: 245.81,
    width: 3.793,
    height: 26.881,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.039,269.848c-4.892,0-9.557-3.602-9.557-10.617s4.665-10.578,9.557-10.578c4.397,0,7.354,2.275,8.378,6.333l3.451-1.215c-1.367-5.192-5.686-8.53-11.828-8.53-6.675,0-13.347,5.005-13.347,13.99s6.407,14.029,13.347,14.029c6.177,0,10.426-3.602,11.864-8.646l-3.296-1.212c-1.102,3.677-3.984,6.446-8.568,6.446Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.962,257.752l-4.019-.869c-2.275-.494-3.447-1.974-3.447-3.906,0-2.504,2.161-4.475,5.192-4.475,3.754,0,5.386,2.656,5.686,4.588l3.338-1.176c-.607-2.918-3.034-6.672-9.098-6.672-4.966,0-8.872,3.79-8.872,8,0,4.019,2.73,6.52,6.559,7.354l3.829.837c2.691.569,4.019,2.236,4.019,4.168,0,2.352-1.819,4.284-5.535,4.284-4.058,0-6.181-2.766-6.446-5.761l-3.564,1.137c.491,3.829,3.564,8,10.048,8,5.722,0,9.286-3.793,9.286-7.961,0-3.754-2.501-6.562-6.976-7.547Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.203 245.81 362.488 245.81 362.488 272.692 378.904 272.692 378.904 269.202 366.203 269.202 366.203 245.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.319 249.261 389.305 249.261 389.305 272.692 393.02 272.692 393.02 249.261 402.005 249.261 402.005 245.81 380.319 245.81 380.319 249.261",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.557,245.81h-9.402v26.881h9.328c6.824,0,12.853-4.588,12.853-13.383s-5.955-13.499-12.778-13.499Zm-.187,23.583h-5.499v-20.284h5.573c4.966,0,9.063,3.412,9.063,10.2,0,6.746-4.171,10.084-9.137,10.084Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.676,267.609c-1.48,0-2.617,1.176-2.617,2.656s1.137,2.614,2.617,2.614,2.653-1.137,2.653-2.614-1.173-2.656-2.653-2.656Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.271,234.551l-42.812-81.62c26.203-7.643,42.514-28.751,42.514-56.641,0-34.607-24.78-61.372-63.622-61.372h-38.18v33.779h30.835c19.718,0,31.265,11.017,31.265,27.891,0,16.344-11.547,27.593-31.265,27.593h-30.835v33.548h19.553l39.139,76.823h43.408Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.565,96.588c0,8.8-3.342,16.145-9.495,20.976h45.624c2.349-6.485,3.573-13.631,3.573-21.274,0-34.607-24.78-61.372-63.622-61.372h-38.18v33.779h30.868c19.718,0,31.232,11.017,31.232,27.891Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.564 234.551 117.741 164.345 75.426 164.345 111.157 234.551 154.564 234.551",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.613,74.553c-.264-.728-.562-1.456-.86-2.184-.794-1.787-1.654-3.54-2.548-5.294-.496-.827-.992-1.72-1.522-2.548-.43-.728-.893-1.489-1.422-2.25-7.477-11.149-18.56-19.818-31.596-24.185-6.12-2.084-12.638-3.176-19.42-3.176h-40.694v33.515h35.136c15.252,0,27.692,12.473,27.692,27.725,0,6.716-2.415,13.201-6.385,17.998-.563.662-1.158,1.323-1.754,1.886-.529.53-1.059,1.059-1.654,1.522h45.193c.132-.298.265-.629.364-.959.463-1.291.86-2.581,1.224-3.838,1.324-5.227,1.985-10.719,1.985-16.443,0-6.848-.993-13.3-2.879-19.222-.231-.86-.529-1.687-.86-2.548Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.889,164.345c.992,2.779,1.489,5.724,1.489,8.8,0,7.61-3.11,14.558-8.139,19.586-4.996,4.996-11.944,8.106-19.553,8.106h-35.136v33.713h40.694c7.312,0,14.292-1.257,20.81-3.639.165-.033.265-.099.397-.165,8.371-3.11,15.914-8.007,22.167-14.227,6.452-6.484,11.448-14.326,14.525-23.06.463-1.291.86-2.581,1.224-3.871,1.324-5.194,1.985-10.687,1.985-16.41,0-3.01-.199-5.988-.563-8.833h-39.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 124.194,
    width: 34.676,
    height: 33.548,
    style: {
      fill: "#d51c29"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.101,
    y: 124.194,
    width: 64.755,
    height: 33.548,
    style: {
      fill: "#ffe100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.345,
    y: 124.194,
    width: 64.755,
    height: 33.548,
    style: {
      fill: "#f57e25"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.175,
    y: 124.194,
    width: 72.635,
    height: 33.548,
    style: {
      fill: "#9cb92d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.809,
    y: 124.194,
    width: 72.635,
    height: 33.548,
    style: {
      fill: "#009a46"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m58.374,13.223h-3.178v8.695h-2.968V.66h8.005c4.018,0,6.506,2.818,6.506,6.327,0,3.058-1.949,5.427-5.157,6.026l5.067,8.905h-3.418l-4.857-8.695Zm1.319-2.639c2.398,0,4.018-1.409,4.018-3.598,0-2.249-1.619-3.688-4.018-3.688h-4.498v7.286h4.498Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.998,0c1.14,0,2.039.899,2.039,2.039,0,1.109-.899,2.009-2.039,2.009-1.109,0-2.009-.899-2.009-2.009,0-1.14.899-2.039,2.009-2.039Zm-1.379,21.918V7.496h2.789v14.422h-2.789Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.534,17.271c.18,1.499,1.319,2.699,3.358,2.699,1.589,0,2.459-.9,2.459-1.919,0-.9-.66-1.589-1.859-1.859l-2.458-.54c-2.249-.479-3.598-2.009-3.598-4.048,0-2.458,2.309-4.558,5.127-4.558,3.958,0,5.187,2.579,5.487,3.868l-2.489.93c-.12-.75-.719-2.399-2.998-2.399-1.439,0-2.399.93-2.399,1.919,0,.87.54,1.499,1.649,1.739l2.338.509c2.609.57,3.988,2.159,3.988,4.288,0,2.039-1.709,4.467-5.277,4.467-3.958,0-5.637-2.548-5.877-4.198l2.549-.899Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.795,13.583l6.267,8.335h-3.538l-4.708-6.356-2.009,2.009v4.348h-2.788V.21h2.788v13.672l6.237-6.386h3.898l-6.147,6.086Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.942,14.542v-2.458h8.125v2.458h-8.125Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.172.66c4.048,0,6.417,2.398,6.417,5.757,0,2.279-1.319,3.898-3.178,4.587,2.429.6,3.838,2.759,3.838,5.127,0,3.358-2.668,5.787-6.566,5.787h-7.436V.66h6.926Zm-.33,9.295c2.369,0,3.778-1.409,3.778-3.388,0-2.009-1.469-3.328-3.898-3.328h-3.538v6.716h3.658Zm.42,9.385c2.369,0,3.988-1.319,3.988-3.388,0-2.039-1.29-3.478-3.868-3.478h-4.198v6.866h4.078Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.306,13.672l3.897-.569c.87-.12,1.109-.57,1.109-1.08,0-1.409-.929-2.579-3.118-2.579-1.979,0-3.088,1.229-3.268,2.908l-2.699-.629c.3-2.759,2.789-4.678,5.907-4.678,4.318,0,5.997,2.459,5.997,5.277v7.226c0,1.259.12,2.009.18,2.369h-2.758c-.06-.36-.15-.899-.15-1.949-.63,1.019-2.069,2.398-4.647,2.398-2.938,0-4.828-2.039-4.828-4.317,0-2.579,1.889-4.018,4.378-4.378Zm5.007,2.069v-.66l-4.407.66c-1.2.18-2.099.87-2.099,2.159,0,1.079.899,2.099,2.339,2.099,2.309,0,4.167-1.109,4.167-4.258Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.84,17.271c.18,1.499,1.319,2.699,3.358,2.699,1.589,0,2.459-.9,2.459-1.919,0-.9-.66-1.589-1.859-1.859l-2.458-.54c-2.249-.479-3.598-2.009-3.598-4.048,0-2.458,2.309-4.558,5.127-4.558,3.958,0,5.187,2.579,5.487,3.868l-2.489.93c-.12-.75-.719-2.399-2.998-2.399-1.439,0-2.399.93-2.399,1.919,0,.87.54,1.499,1.649,1.739l2.338.509c2.609.57,3.988,2.159,3.988,4.288,0,2.039-1.709,4.467-5.277,4.467-3.958,0-5.637-2.548-5.877-4.198l2.549-.899Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.738,17.81c-.81,2.549-3.119,4.558-6.477,4.558-3.868,0-7.256-2.818-7.256-7.706,0-4.528,3.268-7.616,6.896-7.616,4.438,0,6.926,3.059,6.926,7.556,0,.36-.03.72-.06.899h-10.854c.06,2.579,1.919,4.377,4.348,4.377,2.339,0,3.508-1.289,4.048-2.908l2.429.839Zm-2.849-4.587c-.06-2.069-1.409-3.688-3.958-3.688-2.369,0-3.808,1.829-3.928,3.688h7.886Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.661,19.729c-.689,1.379-2.219,2.579-4.467,2.579-4.228,0-6.836-3.358-6.836-7.646,0-4.078,2.758-7.556,6.836-7.556,2.548,0,3.928,1.259,4.407,2.429V.21h2.788v19.04c0,1.379.12,2.429.15,2.668h-2.729c-.06-.33-.15-1.08-.15-1.949v-.24Zm-4.197.09c2.578,0,4.168-2.249,4.168-5.217s-1.56-5.007-4.138-5.007-4.258,2.099-4.258,5.067,1.529,5.157,4.228,5.157Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.393,13.223h-3.179v8.695h-2.968V.66h8.005c4.018,0,6.507,2.818,6.507,6.327,0,3.058-1.949,5.427-5.157,6.026l5.067,8.905h-3.418l-4.857-8.695Zm1.319-2.639c2.398,0,4.018-1.409,4.018-3.598,0-2.249-1.619-3.688-4.018-3.688h-4.498v7.286h4.498Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.601,17.81c-.81,2.549-3.118,4.558-6.477,4.558-3.867,0-7.256-2.818-7.256-7.706,0-4.528,3.269-7.616,6.896-7.616,4.438,0,6.926,3.059,6.926,7.556,0,.36-.029.72-.06.899h-10.854c.061,2.579,1.919,4.377,4.348,4.377,2.339,0,3.509-1.289,4.048-2.908l2.429.839Zm-2.849-4.587c-.06-2.069-1.409-3.688-3.957-3.688-2.369,0-3.809,1.829-3.929,3.688h7.886Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.421,21.918V.21h2.818v21.708h-2.818Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.546,0c1.14,0,2.039.899,2.039,2.039,0,1.109-.899,2.009-2.039,2.009-1.109,0-2.009-.899-2.009-2.009,0-1.14.899-2.039,2.009-2.039Zm-1.379,21.918V7.496h2.788v14.422h-2.788Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.361,13.672l3.897-.569c.87-.12,1.109-.57,1.109-1.08,0-1.409-.929-2.579-3.118-2.579-1.979,0-3.088,1.229-3.268,2.908l-2.699-.629c.3-2.759,2.789-4.678,5.907-4.678,4.317,0,5.997,2.459,5.997,5.277v7.226c0,1.259.119,2.009.18,2.369h-2.759c-.06-.36-.149-.899-.149-1.949-.63,1.019-2.069,2.398-4.647,2.398-2.938,0-4.828-2.039-4.828-4.317,0-2.579,1.89-4.018,4.378-4.378Zm5.007,2.069v-.66l-4.407.66c-1.199.18-2.099.87-2.099,2.159,0,1.079.899,2.099,2.339,2.099,2.309,0,4.167-1.109,4.167-4.258Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.695,21.918V.21h2.788v9.325c.69-1.289,2.369-2.458,4.768-2.458,4.378,0,6.627,3.358,6.627,7.556,0,4.288-2.429,7.676-6.717,7.676-2.129,0-3.778-.929-4.678-2.488v2.099h-2.788Zm7.046-12.353c-2.488,0-4.287,1.949-4.287,5.067s1.799,5.157,4.287,5.157c2.579,0,4.258-2.039,4.258-5.157s-1.649-5.067-4.258-5.067Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.986,0c1.14,0,2.039.899,2.039,2.039,0,1.109-.899,2.009-2.039,2.009-1.109,0-2.009-.899-2.009-2.009,0-1.14.899-2.039,2.009-2.039Zm-1.379,21.918V7.496h2.788v14.422h-2.788Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.323,21.918V.21h2.818v21.708h-2.818Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.448,0c1.14,0,2.039.899,2.039,2.039,0,1.109-.899,2.009-2.039,2.009-1.109,0-2.009-.899-2.009-2.009,0-1.14.899-2.039,2.009-2.039Zm-1.379,21.918V7.496h2.788v14.422h-2.788Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.563,7.496h3.118v2.548h-3.118v7.496c0,1.319.54,1.979,2.009,1.979.36,0,.87-.06,1.109-.12v2.398c-.239.09-.959.27-1.919.27-2.458,0-4.018-1.499-4.018-4.108v-7.916h-2.759v-2.548h.78c1.559,0,2.219-.959,2.219-2.219v-2.339h2.578v4.558Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.219,27.945l3.599-7.616-6.207-12.833h3.238l4.498,9.954,4.317-9.954h3.028l-9.385,20.449h-3.089Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.f7306ad70af4ed939b920074fd956a86.svg";
export { ForwardRef as ReactComponent };